module.exports = __webpack_public_path__ + "static/img/elastic_logo.6d50f83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/elastic_logo.jpg
// module id = NsB1
// module chunks = 2